import React from 'react';

const STATUS_STYLES: Record<string, string> = {
  healthy: 'bg-green-100 text-green-800',
  warning: 'bg-amber-100 text-amber-800',
  replace: 'bg-red-100 text-red-800',
  warm_up: 'bg-blue-100 text-blue-800',
  quarantine: 'bg-gray-100 text-gray-700',
  retired: 'bg-gray-200 text-gray-600',
};

export const HealthStatusBadge: React.FC<{ status: string; since?: string | null }> = ({ status, since }) => (
  <div>
    <span className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-xs font-medium ${STATUS_STYLES[status] ?? 'bg-gray-100 text-gray-700'}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${status === 'healthy' ? 'bg-green-500' : status === 'warning' ? 'bg-amber-500' : status === 'replace' ? 'bg-red-500' : 'bg-blue-500'}`} />
      {status.replace('_', ' ')}
    </span>
    {since && <p className="text-[10px] text-muted-foreground mt-0.5">Since {new Date(since).toLocaleDateString()}</p>}
  </div>
);

export const UsageTypeBadge: React.FC<{ label: string }> = ({ label }) => {
  const colors: Record<string, string> = {
    'Manual Dialing': 'bg-blue-100 text-blue-800',
    'Text Blast': 'bg-green-100 text-green-800',
    'AI Caller': 'bg-purple-100 text-purple-800',
    'Follow-Up': 'bg-indigo-100 text-indigo-800',
    'Auto Dialing': 'bg-amber-100 text-amber-800',
  };
  return (
    <span
      className={`inline-flex items-center whitespace-nowrap px-2 py-0.5 rounded text-xs font-medium ${colors[label] ?? 'bg-gray-100 text-gray-700'}`}
    >
      {label}
    </span>
  );
};

export const CarrierIssueBadge: React.FC<{ issues: string[] }> = ({ issues }) => {
  if (!issues.length) return <span className="text-muted-foreground text-xs">—</span>;
  return (
    <div className="space-y-1">
      {issues.map((issue) => (
        <span key={issue} className="block text-xs text-amber-700 bg-amber-50 px-1.5 py-0.5 rounded">
          {issue}
        </span>
      ))}
    </div>
  );
};

export const WarmupStatusBadge: React.FC<{
  warmupDay: number;
  callsToday: number;
  dailyCallLimit: number | null;
  textsToday: number;
  dailyTextLimit: number | null;
  healthStatus: string;
}> = ({ warmupDay, callsToday, dailyCallLimit, textsToday, dailyTextLimit, healthStatus }) => {
  if (healthStatus !== 'warm_up') return null;
  return (
    <div className="text-xs text-muted-foreground">
      <div>Day {warmupDay}</div>
      <div>{callsToday}/{dailyCallLimit ?? '—'} calls</div>
      <div>{textsToday}/{dailyTextLimit ?? '—'} texts</div>
    </div>
  );
};
